import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";


export class Delegate extends EntityDto implements IEntityDto {
  Delegation_Id: string;
  DelegationName: string;
  DelegationDescription: string; 
  IsActive: boolean;
  Emp_Ref_Id: string;
  EmployeeName: string;
  TotalCount: number;

  constructor() {
    super();
    this.Delegation_Id = '00000000-0000-0000-0000-000000000000';
    this.DelegationDescription = '';
    this.DelegationName = ''; 
    this.Emp_Ref_Id = '';
    this.EmployeeName = '';
    this.TotalCount = 0;
    this.IsActive = true;

    this.EntityMetaData = [ 
       { FieldName: 'DelegationName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Delegate Name is required' },
      //{ FieldName: 'DelegationDescription', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Description is required' }
    ];
  }
}